import { type SubscriptionTerm } from '~/vendor/cx-sdk/subs';
import { trackEvent } from '~/vendor/cx-web/feature-tracking/dataLayer';

export const trackComponentWallCtaClick = ({
  feature,
  isUpgrade,
  price,
  selection,
  term,
}: {
  feature: string;
  isUpgrade: boolean;
  price: string;
  selection?: 'Essential' | 'Premium' | 'WhoScored Premium';
  term: SubscriptionTerm | undefined;
}) => {
  trackEvent('paywall_cta', {
    eventLabel: isUpgrade ? 'Upgrade CTA' : 'Paywall CTA',
    feature,
    pageUrl: window.location.href,
    product: `${term} - ${price}`,
    referrerUrl: document.referrer,
    selection,
    upgradeOrPurchase: isUpgrade ? 'Upgrade' : 'Purchase',
  });
};
